import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import navigatorService from "../navigatorService";
import watermarkImageService from "./watermarkImageService";
import { MAP_IMAGE_KEY, MAP_IMAGE_URL, MEDIASTORAGE_URL } from "../../constants/Constants";
import takePhotoService from "../takePhotoService";
import { LogFirebase } from "../firestore";
import CustomToast from "../../components/UI/customToast";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { TOAST_MESSAGE } from "../../constants/ToastMsgLocalize";
import Localize from "../../locale/Localize";
import { deviceDetailsAllowed } from "../../shared/function";
import { sendDataTrack } from "../../shared/dataTrackFunction";

const WIDTH = 640;
const HEIGHT = 640;

class UploadMapService {
    uploadMap(from, latitude, longitude) {
        if (GLOBAL_MEETING_DATA.isAgent) {
            return false;
        }

        LogFirebase("Map_image", "_started_uploading_map", "");
        const deviceOrientation = navigatorService.getOrientation();
        let watermarkImg = new Image();
        let objVal = watermarkImageService.__watermarkImage.fetchImageWaterMark({
            screenType: "location",
            width: WIDTH,
            height: HEIGHT,
            localOrientation: deviceOrientation,
            bookmark: "",
            liveLat: latitude,
            liveLong: longitude,
        });
        const { imageSrc, canvasHeight } = objVal;

        watermarkImg.src = imageSrc;
        let imgurl = "";
        if (from && from === "not shared") {
            let tempLang = PublicVariables?.currentLanguageObj?.languageCode;
            let convertedTempLang = tempLang.replace("_", "-");
            imgurl = MEDIASTORAGE_URL + "appdata/location/" + convertedTempLang + ".jpg";
        }
        if (latitude !== null && longitude !== null && from !== "not shared") {
            const marker = "markers=color:red%7Clabel:L%7C";
            imgurl =
                MAP_IMAGE_URL +
                latitude +
                "," +
                longitude +
                "&zoom=17&size=" +
                WIDTH +
                "x" +
                HEIGHT +
                "&&zoom=15&" +
                marker +
                latitude +
                "," +
                longitude +
                MAP_IMAGE_KEY;
        }

        if (deviceDetailsAllowed()) {
            LogFirebase("Map_image", "_map_imgurl", imgurl);
        }

        let xhr = new XMLHttpRequest();
        xhr.open("GET", imgurl, true);
        xhr.responseType = "blob";
        xhr.send();
        xhr.this = this;
        xhr.onload = function () {
            LogFirebase("Map_image", "_mapLoaded", "");
            const blob = this.response;
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.this = xhr.this;
            reader.onload = function () {
                const mapImg = new Image();
                const base64data = reader.result;
                mapImg.src = base64data;
                const canvas = document.getElementById("screenshotcanvas");
                if (canvas) {
                    canvas.height = canvasHeight;
                    canvas.width = WIDTH;
                    const context = canvas.getContext("2d");
                    mapImg.this = reader.this;
                    mapImg.onload = function () {
                        context.drawImage(mapImg, 0, 0);
                        context.drawImage(watermarkImg, 0, 0);
                        const imgdata = canvas.toDataURL("image/jpeg");
                        const bookmark = null;
                        const blobFinal = watermarkImageService.__base64ToBlobImage.convertData(imgdata);
                        /* Handle upload file API */
                        mapImg.this.sendUploadMapMsg(blobFinal, bookmark, imgurl);
                    };
                }
            };
        };
    }

    sendUploadMapMsg(blobFinal, bookmark, imgurl) {
        takePhotoService.uploadImage("location", blobFinal, bookmark, (response) => {
            const result = response.data;
            if (response.success > 0) {
                //send upload map image notification
                if (CALL_DATA.localIdentity && result?.fileName) {
                    const thumb_url = encodeURI(result?.thumbUrl);
                    const uploadMapImageMessage = {
                        notification_type: NOTIFICATION_TYPES.TAKE_PHOTO.STREAMING_USER_TO_ALL,
                        identity: CALL_DATA.localIdentity,
                        status: "2",
                        prevUploadStatus: "1",
                        device_type: GLOBAL_MEETING_DATA.device_type,
                        image_url: result?.fileUrl,
                        thumbURL: thumb_url,
                        imageName: result?.fileName,
                        isLocationImage: "true",
                    };
                    sendDataTrack(uploadMapImageMessage);
                }
                LogFirebase("Map_image", "_upload_map_success", "");
            } else {
                LogFirebase("Map_image", "_upload_map_failed", "");
                LogFirebase("Map_image", "_map_upload_error_", {
                    mapURL: imgurl,
                    error: result?.error?.toString(),
                    isMapImage: true,
                    status: "fail",
                });
                const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
                CustomToast.error(localisedValues[TOAST_MESSAGE.LOCATION_IMAGE_UPLOAD_FAILED]);
            }
        });
    }
}

export default new UploadMapService();
